import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPeriodicityList,
	addNewPeriodicity,
	updatePeriodicity,
	deletePeriodicity,
	getPeriodicity,
	getPeriodicityByCode,
} from '../periodicity/thunk';

export const initialState = {
	itemPeriodicityList: [],
	itemPeriodicityDetail: null,
	isPeriodicityLoading: false,
	isPeriodicitySuccess: false,

	periodicityList: [],
	periodicityListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const PeriodicitySlice = createSlice({
	name: 'Periodicities',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPeriodicity.fulfilled, (state, action) => {
			state.isPeriodicityLoading = false;
			state.isPeriodicitySuccess = true;
			state.itemPeriodicityDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPeriodicity.pending, state => {
			state.isPeriodicityLoading = true;
			state.isPeriodicitySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPeriodicity.rejected, (state, action) => {
			state.isPeriodicityLoading = false;
			state.isPeriodicitySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getPeriodicityByCode.fulfilled, (state, action) => {
			state.isPeriodicityLoading = false;
			state.isPeriodicitySuccess = true;
			state.itemPeriodicityDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPeriodicityByCode.pending, state => {
			state.isPeriodicityLoading = true;
			state.isPeriodicitySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPeriodicityByCode.rejected, (state, action) => {
			state.isPeriodicityLoading = false;
			state.isPeriodicitySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getPeriodicityList.pending, state => {
			state.isPeriodicitySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPeriodicityList.fulfilled, (state, action) => {
			state.itemPeriodicityList = action.payload;
			state.periodicityList = action.payload;
			state.isLoadingList = false;
			state.isPeriodicitySuccess = true;

			let periodicityListSelect = [];
			action.payload.map(item =>
				periodicityListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.periodicityListSelect = periodicityListSelect;
		});
		builder.addCase(getPeriodicityList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPeriodicitySuccess = true;
		});
		builder.addCase(addNewPeriodicity.fulfilled, (state, action) => {
			state.itemPeriodicityList.push(action.payload);
			state.periodicityList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPeriodicity.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPeriodicity.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePeriodicity.fulfilled, (state, action) => {
			state.itemPeriodicityList = state.itemPeriodicityList.map(periodicity =>
				periodicity.periodicityname === action.payload.old_periodicity
					? { ...periodicity, ...action.payload.updated_periodicity }
					: periodicity
			);
			state.periodicityList = state.periodicityList.map(periodicity =>
				periodicity._id.toString() === action.payload._id.toString()
					? { ...periodicity, ...action.payload }
					: periodicity
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePeriodicity.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePeriodicity.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePeriodicity.fulfilled, (state, action) => {
			state.itemPeriodicityList = current(state.itemPeriodicityList).filter(
				item => item._id !== action.payload._id
			);
			state.periodicityList = current(state.periodicityList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePeriodicity.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePeriodicity.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = PeriodicitySlice.actions;

export default PeriodicitySlice.reducer;
